import { useEffect, useState } from 'react';

export const ONE_DAY = 86400 * 1000;

export const useShowUXFeedback = (
  /* A number in milliseconds that specifies how long time the feedback should be
  hidden (from timeSinceLastShown)  */
  timeout: number,
  /* A number in milliseconds that specifies the last time the feedback was shown */
  timeSinceLastShown: number,
  /* A number between 0 - 1 that specifies how often the feedback should appear,
  where 0 is 0% and 1 is 100%.  */
  distribution: number = 1
) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    setShouldShow(
      Math.random() < distribution &&
        new Date().valueOf() - timeout > timeSinceLastShown
    );
  }, [distribution, timeout, timeSinceLastShown]);

  return shouldShow;
};
